export type { BlogPost } from "./blogTypes";
import type { BlogPost } from "./blogTypes";
import { redFlagsDutchRentalContractExpats } from "./blog/red-flags-dutch-rental-contract-expats";
import { understandingRentIncreaseRulesNetherlands } from "./blog/understanding-rent-increase-rules-netherlands";
import { howMuchDepositLandlordAskNetherlands } from "./blog/how-much-deposit-landlord-ask-netherlands";
import { fixedVsIndefiniteRentalContractNetherlands } from "./blog/fixed-vs-indefinite-rental-contract-netherlands";
import { tenantRightsNetherlandsCompleteGuide } from "./blog/tenant-rights-netherlands-complete-guide";
import { serviceCostsNetherlandsWhatTenantsShouldKnow } from "./blog/service-costs-netherlands-what-tenants-should-know";
import { sublettingRulesNetherlandsWhatYouNeedToKnow } from "./blog/subletting-rules-netherlands-what-you-need-to-know";
import { landlordEnteringApartmentRightsNetherlands } from "./blog/landlord-entering-apartment-rights-netherlands";
import { rentalContractLanguageDutchVsEnglishWhichPrevails } from "./blog/rental-contract-language-dutch-vs-english-which-prevails";
import { huurcommissieHowToFileComplaintNetherlands } from "./blog/huurcommissie-how-to-file-complaint-netherlands";
import { rentalDepositReturnNetherlandsHowToGetItBack } from "./blog/rental-deposit-return-netherlands-how-to-get-it-back";
import { rentalContractChecklistBeforeSigningNetherlands } from "./blog/rental-contract-checklist-before-signing-netherlands";

export const blogPosts: BlogPost[] = [
  redFlagsDutchRentalContractExpats,
  understandingRentIncreaseRulesNetherlands,
  howMuchDepositLandlordAskNetherlands,
  fixedVsIndefiniteRentalContractNetherlands,
  tenantRightsNetherlandsCompleteGuide,
  serviceCostsNetherlandsWhatTenantsShouldKnow,
  sublettingRulesNetherlandsWhatYouNeedToKnow,
  landlordEnteringApartmentRightsNetherlands,
  rentalContractLanguageDutchVsEnglishWhichPrevails,
  huurcommissieHowToFileComplaintNetherlands,
  rentalDepositReturnNetherlandsHowToGetItBack,
  rentalContractChecklistBeforeSigningNetherlands,
];

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogPosts.find((post) => post.slug === slug);
}
